import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { SumDetails } from "../../common/app-data/AppData";

interface SumDetailsTableProps {
  details: SumDetails[];
}

export default function SumDetailsTable(props: SumDetailsTableProps) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
        <TableHead>
          <TableRow>
            <TableCell>Obrok</TableCell>
            <TableCell align="right">Total</TableCell>
            <TableCell align="right">Vegan</TableCell>
            <TableCell align="right">Vegetarijanac</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.details.map((row) => (
            <TableRow key={row.name} style={{ height: "38px" }}>
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="right">{row.total}</TableCell>
              <TableCell align="right">{row.vegan}</TableCell>
              <TableCell align="right">{row.vegetarian}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
